/**
 * 法務ページに載せる事業者情報。
 *
 * **ここはまだ埋まっていない。** 実在の事業者情報を入れずに公開してはいけない。
 * `{{...}}` のまま画面に出るので、埋め忘れは目視で分かる。
 * 埋めるべき項目は docs/deployment.md の「法務ページ」に控えてある。
 *
 * 1 箇所に集めてあるのは、利用規約・プライバシーポリシー・特定商取引法の
 * 3 ページで同じ社名や連絡先を別々に書いてしまうのを防ぐため。
 */
export const BUSINESS_INFO = {
  /** 事業者の名称 (法人名) */
  companyName: '{{社名}}',
  /** 運営責任者 / 代表者名 */
  representative: '{{代表者名}}',
  /** 所在地。請求があったら遅滞なく開示する旨をページ側に書いてある */
  address: '{{所在地}}',
  /** 問い合わせ窓口のメールアドレス */
  contactEmail: '{{問い合わせ用メールアドレス}}',
  /** 電話番号。請求があったら遅滞なく開示する旨をページ側に書いてある */
  phone: '{{電話番号}}',
  /** 個人情報の取り扱いに関する窓口 (別に置くなら差し替える) */
  privacyContactEmail: '{{個人情報問い合わせ窓口のメールアドレス}}',
} as const;

/** 各ページの最終改定日 (YYYY-MM-DD)。改定したら必ず更新する。 */
export const LEGAL_REVISED_ON = '{{制定日 YYYY-MM-DD}}';

/** 事業者情報がまだプレースホルダのままか */
export function hasPlaceholders(): boolean {
  return [...Object.values(BUSINESS_INFO), LEGAL_REVISED_ON].some((value) => value.includes('{{'));
}
